import React from 'react'
import {
  AddressAutocomplete,
  AutocompleteErrorCodes
} from '@commutifi-fe/commutifi-specific/Presentation/AddressAutocomplete'
import { FormItemInjectedProps, googleGeocodeToLocalGeocode } from 'shared/interfaces'
import { AddressGeocodeValue } from 'shared/interfaces/Commute'
import { Location } from 'shared/interfaces/Location'
import { GeocoderResult } from 'shared/interfaces/thirdParty/google'
import { Overwrite } from 'utility-types'

export interface AddressAutocompleteInputProps
  extends Overwrite<
    FormItemInjectedProps<AddressGeocodeValue>,
    {
      onChange?: (value: AddressGeocodeValue | AutocompleteErrorCodes | null) => void
    }
  > {
  // Place holder text or DOM element containing placeholder text
  placeholder?: string | null
  // Location Bias for more targeted autocomplete results
  locationBias?: Location
  size?: React.ComponentProps<typeof AddressAutocomplete>['size']
  isInteractive?: boolean
}

function AddressAutocompleteInput({ id, onChange, value, ...rest }: AddressAutocompleteInputProps) {
  const handleSelect = (address: GeocoderResult | null) => {
    const formattedAddress = address
      ? {
          value: address.formattedAddress,
          ...googleGeocodeToLocalGeocode(address)
        }
      : null

    if (onChange) {
      onChange(formattedAddress)
    }
  }

  const handleError = (errorCode: AutocompleteErrorCodes) => {
    // We need to pass the error code to onChange since we want to trigger the validation
    // of the input to display an error
    if (onChange) {
      onChange(errorCode)
    }
  }

  return <AddressAutocomplete id={id} onSelect={handleSelect} value={value?.value} onError={handleError} {...rest} />
}

export default AddressAutocompleteInput
